@use "src/theme";
.message {
  font-size: var(--text-xs);
  color: var(--color-muted);

  &.error {
    color: var(--color-danger-text);
  }
}
